import { render, staticRenderFns } from "./SearchFloatButton.vue?vue&type=template&id=240d20b6&scoped=true"
import script from "./SearchFloatButton.vue?vue&type=script&lang=ts"
export * from "./SearchFloatButton.vue?vue&type=script&lang=ts"
import style0 from "./SearchFloatButton.vue?vue&type=style&index=0&id=240d20b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240d20b6",
  null
  
)

export default component.exports